import { isUndefined, isArray, isPlainObject, isDate, each, toPairs } from 'lodash/fp';

// heavily influenced by https://github.com/therealparmesh/object-to-formdata
export const toFormData = (input, data = new FormData(), parentKey) => {
	if (isUndefined(input)) {
		return data;
	} if (isArray(input)) {
		each(([index, value]) => toFormData(value, data, `${parentKey}[${index}]`), toPairs(input));
	} else if (isDate(input)) {
		data.append(parentKey, input.toISOString());
	} else if (isPlainObject(input)) {
		each(([key, value]) => toFormData(value, data, parentKey ? `${parentKey}[${key}]` : key), toPairs(input));
	} else {
		data.append(parentKey, input);
	}
	return data;
};

export const determineNextPageOnDelete = ({ page, total }, limit) => {
	if (page > 1 && total - 1 <= ((page - 1) * limit)) {
		page--;
	}
	return page;
};
